import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Tags from "./Tags";
import AddEvents from "./AddEvents";
import ViewDetailsEvents from "./ViewDetailsEvents";
import { SeoFormProvider } from "../Context/SeoFormContext";
import ViewTagSeoSettings from "./ViewTagSeoSettings";
const CreatePost = lazy(() => import("../posts/CreatePost"));
const ViewPosts = lazy(() => import("../posts/ViewPosts"));
const ViewDetailsPosts = lazy(() => import("../posts/ViewDetails"));

function PostsModule() {
  return (
    <SeoFormProvider>
      <Suspense fallback={null}>
        <Routes>
          <Route path="createPost" element={<CreatePost />} />
          <Route path="addEvents" element={<AddEvents />} />
          <Route path="viewPosts" element={<ViewPosts />} />
          <Route path="viewEventsPosts" element={<ViewPosts />} />
          <Route path="expiredEventsPosts" element={<ViewPosts />} />
          <Route path="returnForEdits" element={<ViewPosts />} />
          <Route path="archived" element={<ViewPosts />} />
          <Route path="tags" element={<Tags />} />
          <Route path="viewDetailsPosts" element={<ViewDetailsPosts />} />
          <Route path="viewDetailsEvents" element={<ViewDetailsEvents />} />
          <Route
            path="viewTagsSeoSettings/:id"
            element={<ViewTagSeoSettings />}
          />
        </Routes>
      </Suspense>
    </SeoFormProvider>
  );
}

export default PostsModule;
